import React, { Children } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const MediaGrid = ({ children, className, theme }) => {
	const gridCx = cx(
		styles.MediaGrid,
		styles[`MediaGrid_column_${Children.count(children)}`],
		styles[`MediaGrid_theme_${theme}`],
		className
	);

	return (
		<div className={gridCx}>
			{Children.map(children, (child) => (
				<div className={styles.MediaGrid__Col}>{child}</div>
			))}
		</div>
	);
};

MediaGrid.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	theme: PropTypes.oneOf(['revert'])
};

export default MediaGrid;
